import { Component, OnInit, AfterViewInit, PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { Title, Meta } from '@angular/platform-browser';
import * as $ from 'jquery';
import { LinkService } from '../../../_services/langhfre.service';
declare function ire(string,{}): any;
@Component({
  selector: 'app-personal-dictionary',
  templateUrl: './personal-dictionary.component.html',
  styleUrls: ['./personal-dictionary.component.scss']
})
export class PersonalDictionaryComponent implements OnInit {

  constructor(
    private titleService: Title,
    private metaTagService: Meta,
    @Inject(PLATFORM_ID) private platformId: Object,
    private LinkService: LinkService
  ) { }

  ngOnInit() {
    this.titleService.setTitle('나만의 개인용 사전으로 트링카 맞춤화하기');
    this.metaTagService.updateTag({ name: 'description', content: "브랜드 이름이나 새로운 기술과 같이 트링카가 인식하지 못하는 단어를 개인용 사전에 추가하여 철자 오류 경고를 피해 보세요." });
    this.metaTagService.updateTag({ property: 'og:title', content: '나만의 개인용 사전으로 트링카 맞춤화하기' });
    this.metaTagService.updateTag({ property: 'og:description', content: "브랜드 이름이나 새로운 기술과 같이 트링카가 인식하지 못하는 단어를 개인용 사전에 추가하여 철자 오류 경고를 피해 보세요." });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/kr/features/personal-dictionary' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.metaTagService.updateTag({ property: 'og:image', content: 'https://www.trinka.ai/assets/images/Personal-Dictionary.png' });
    this.metaTagService.updateTag({ name: 'twitter:title', content: '나만의 개인용 사전으로 트링카 맞춤화하기' });
    this.metaTagService.updateTag({ name: 'twitter:description', content: "브랜드 이름이나 새로운 기술과 같이 트링카가 인식하지 못하는 단어를 개인용 사전에 추가하여 철자 오류 경고를 피해 보세요." });
    this.metaTagService.updateTag({ name: 'twitter:image', content: 'https://www.trinka.ai/assets/images/Personal-Dictionary.png' });
    this.metaTagService.updateTag({ name: 'language', content: 'ko-kr' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/kr/features/personal-dictionary' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/features/personal-dictionary' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/features/personal-dictionary' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ko-kr', href: 'https://www.trinka.ai/kr/features/personal-dictionary' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ja-jp', href: 'https://www.trinka.ai/jp/features/personal-dictionary' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-cn', href: 'https://trinka.enago.cn/features/personal-dictionary' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-tw', href: 'https://www.trinka.ai/tw/features/personal-dictionary' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'es-es', href: 'https://www.trinka.ai/es/features/personal-dictionary' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'pt-pt', href: 'https://www.trinka.ai/pt/features/personal-dictionary' });
    if (isPlatformBrowser(this.platformId)) {
      // $.getScript('../../../assets/js/particles.min.js', function(){});
      $.getScript('../../../assets/js/wisepop.js', function () { });
    }
    
  }
  scroll(el: HTMLElement) {
    el.scrollIntoView({ behavior: 'smooth' });
  }
  ngAfterViewInit() {
    if (isPlatformBrowser(this.platformId)) {
      $.getScript('../../../../assets/js/home_client_slider.js', function () { });
      $('#closedPopup, #wordPluginPopup').click(function () {
        $('iframe.youtubeVideoForTryDemo').remove()
      });

      $('#VewiVideoSection').click(function () {
        if (!$('#iframe').length) {
          $('#iframeHolder').html('<iframe class="youtubeVideoForTryDemo" id="iframe" src="https://www.youtube.com/embed/5KsBh4PQUPI" width="100%" height="450"></iframe>');
        }
      });

    }
  }

  generateGuid() {
    var result, i, j;
    result = '';
    for(j=0; j<32; j++) {
      if( j == 8 || j == 12 || j == 16 || j == 20)
        result = result + '-';
      i = Math.floor(Math.random()*16).toString(16).toUpperCase();
      result = result + i;
    }
    return result;
  }
}
